<template>
	<div class="o_items" v-if="items.length > 0">
		<ul>
			<li v-for="item in items" class="pt-3">
				<div class="d-flex flex-row align-items-center">
					<span class="mr-3">
						<span class="rounded-circle profile-image d-block " v-if="item.hasOwnProperty('image')"
							  v-bind:style="{
								  'background-image': 'url(' + item.image + ')',
								  'background-size': 'cover'
                           }"
						>
						</span>
					</span>

					<div class="info-card-text flex-1" v-if="item != null">
						<a href="javascript:void(0);" class="fs-xl text-truncate text-truncate-lg text-info" >
							{{item.title}}
						</a>
                        <span class="text-truncate text-truncate-xl" v-if="parseInt(item.item_discount) > 0">
							Discount : | {{ item.item_discount }}
						</span>


                        <span class="text-truncate text-truncate-xl">
							{{ item.id }} | {{ item.uniq_id }}
						</span>

						<div class="modif_block" v-if="item.modifiers.length > 0">
							<div class="small" v-for="mod in item.modifiers">
								|__ {{mod.amount}} * {{mod.title}}
							</div>
						</div>
					</div>

					<div class="price_item fs-xxl">
						<div class="prod_price bold color-primary-900 mt-4">
							<small>{{item.qty}}</small> * {{item.item_cost}}
							<span  class="woocommerce-Price-currencySymbol  fs-sm"> {{item.item_cost | getCurrency}}</span>
						</div>
					</div>

				</div>
			</li>
		</ul>

		<div class="d-flex flex-row align-items-center border-top mt-3">
			<div class="info-card-text flex-1 fs-xxl">
				{{__t('ORDER.TOTAL')}}
			</div>
			<div class="price_item fs-xxl">
				<div class="prod_price bold color-primary-900 mt-4">
					{{order_price.total}}
					<span  class="woocommerce-Price-currencySymbol  fs-sm"> {{order_price.total | getCurrency}}</span>
				</div>
			</div>
		</div>


        <div class="d-flex flex-row align-items-center border-top mt-3" v-if="parseFloat(order_price.discount) > 0">
            <div class="info-card-text flex-1 fs-xl">
                {{__t('ORDER.DISCOUNT')}}
            </div>
            <div class="price_item fs-xl">
                <div class="prod_price bold color-primary-900 mt-4">
                    {{order_price.discount}}
                    <span  class="woocommerce-Price-currencySymbol  fs-sm"> {{order_price.discount | getCurrency}}</span>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row align-items-center border-top mt-3"  v-if="parseFloat(order_price.delivery) > 0">
            <div class="info-card-text flex-1 fs-xl">
                {{__t('ORDER.DELIVERY')}}
            </div>
            <div class="price_item fs-xl">
                <div class="prod_price bold color-primary-900 mt-4">
                    {{order_price.delivery}}
                    <span  class="woocommerce-Price-currencySymbol  fs-sm"> {{order_price.delivery | getCurrency}}</span>
                </div>
            </div>
        </div>

	</div>
</template>

<script>
export default {
	name: "order_products",

	data() {
		return {

		}
	},

	props : {
		order : {
			type : Object
		}
	},




	computed : {
		items () {
			if(this.order.hasOwnProperty("products")) {
				return this.order.products.map(function(item) {
                    if(item.hasOwnProperty("image")) {
                        item.image = item.image.replace("{width}",150);
                        item.image = item.image.replace("{height}",150);
                    }

                    if(item.hasOwnProperty("modifiers")) {
                        if(item.modifiers == undefined || item.modifiers == null ) {
                            item.modifiers = [];
                        }
                    }

                    return item;
                });
			}

			return []
		},

        order_price() {
            if(this.order.hasOwnProperty("cost")) {
                return this.order.cost;
            }

            return {
                "delivery" : 0,
                "total" : 0,
                "subtotal" : 0,
                "discount" : 0,
            };
        },
	},
}
</script>

<style scoped>
 .o_items ul li {
	 list-style: none;
 }
</style>
